// @flow
import React, { Component } from 'react';

type Props = {
  at: number,
  total: number
}

class Progress extends Component<Props> {
  render() {
    const style = {
      width: (this.props.at / this.props.total * 100) + '%'
    }

    return (
      <div className='progress' style={style}>
      </div>
    );
  }
}

export default Progress;



// WEBPACK FOOTER //
// ./src/components/Progress.js